// extracted by mini-css-extract-plugin
module.exports = {"quickAddWrapper":"product-ui-quick-add-button_quickAddWrapper__s9LGr","quickAddIcon":"product-ui-quick-add-button_quickAddIcon__zoCu6"};